<template>
  <div
    class="root-base-time-picker"
    style="width: 100%; position: relative;">
    <v-text-field
      :value="internalValue"
      readonly
      rounded
      filled
      :disabled="disabled"
      v-bind="$attrs"
      @focus="handleClickTextField"
    >
      <template v-slot:append>
        <v-icon>
          mdi-clock-outline
        </v-icon>
      </template>
    </v-text-field>
    <vue-timepicker
      v-model="internalValue"
      input-class="vue-timepicker-input"
      hide-clear-button
    ></vue-timepicker>
  </div>
</template>

<script>
import 'vue2-timepicker/dist/VueTimepicker.css'

import VueTimepicker from 'vue2-timepicker'

export default {
  name: 'BaseTimePicker',
  components: {
    VueTimepicker
  },
  inheritAttrs: false,
  props: {
    value: {
      type: [String],
      default: ''
    },
    inputClass: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {
      internalValue: this.value
    }
  },
  watch: {
    internalValue(newValue) {
      if (this.isValidTime(newValue)) {
        this.$emit('input', newValue)
      } else if (!newValue || newValue === '') {
        this.$emit('input', '')
      }
    }
  },
  methods: {
    handleClickTextField(e) {
      e.preventDefault()
      const root = e.target.closest('.root-base-time-picker')
      const input = root.querySelector('.vue-timepicker-input')
      input.focus()
    },
    isValidTime(value) {
      const timePattern = /^([01]\d|2[0-3]):([0-5]\d)$/
      return timePattern.test(value)
    }
  }
}
</script>

<style>
._error--text input {
  color: #ef2956 !important;
  caret-color: #ef2956 !important;
}
._green--text input {
  color: #01bb00 !important;
  caret-color: #01bb00 !important;
}
.vue__time-picker .hint {
  display: none;
}
.vue__time-picker.time-picker {
  height: 0;
  padding: 0;
  margin: 0;
  position: absolute;
  top: 24px;
  left: 24px;
}
.vue__time-picker input.display-time.vue-timepicker-input {
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  opacity: 0;
}
</style>
